var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoubleChevronRightIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.198 12.05L9.18505 5.5H3.49805L7.51155 12.05L3.56155 18.5H9.24805L13.198 12.05ZM21.198 12.05L17.185 5.5H11.498L15.5115 12.05L11.5615 18.5H17.248L21.198 12.05Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleChevronRightIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Double_Chevron_Right_icon.c715abbc16ebc31aa7d5d137da589787.svg";